import find from "lodash.find";
import React from "react";
import PropTypes from "prop-types";
import AddUsers from "./add-users/AddBulkSubscriptionUsers";
import ManageUser from "./user/ManageBulkSubscriptionUser";
import { formatUTCDateString } from "utils/dateUtil";
import { STATUS_ACTIVE } from "common/constants/Constants";
import styles from "./styles.module.scss";

class ManageBulkSubscription extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeMenuId: null
        };

        this._showMenu = this._showMenu.bind(this);
        this._closeMenu = this._closeMenu.bind(this);
    }

    _showMenu(id) {
        this.setState({ activeMenuId: id });

        window.addEventListener("click", this._closeMenu);
    }

    _closeMenu() {
        this.setState({ activeMenuId: null });

        window.removeEventListener("click", this._closeMenu);
    }

    render() {
        const {
            errors,
            name,
            endDate,
            redirectToSubscriptions,
            users,
            maxUsersCount,
            status,
            email,
            onEmailChange,
            onAddUser,
            userActionState,
            resetUserAction,
            userId,
            numberOfAdmins,
            addAdmin,
            removeAdmin,
            removeUser,
            resendVerificationEmail
        } = this.props;

        const {
            activeMenuId
        } = this.state;

        const self = find(users, { id: userId });
        const userIsActive = self && self.active;

        return (
            <div className={ styles.content }>
                <RightRail
                    redirectToSubscriptions={ redirectToSubscriptions }
                    name={ name }
                    endDateString={ endDate }
                    userIsActive={ userIsActive }
                    status={ status }
                />
                <main className={ styles.manageBulkSubscription }>
                    <h1 className={ styles.header }>
                        Manage your bulk subscription
                    </h1>
                    <div className={ styles.addUsers }>
                        <AddUsers
                            errors={ errors }
                            maxUsersCount={ maxUsersCount }
                            users={ users }
                            email={ email }
                            onEmailChange={ onEmailChange }
                            onAddUser={ onAddUser }
                        />
                    </div>
                    <Users
                        selfId={ userId }
                        users={ users }
                        numberOfAdmins={ numberOfAdmins }
                        userActionState={ userActionState }
                        resetUserAction={ resetUserAction }
                        activeMenuId={ activeMenuId }
                        showMenu={ this._showMenu }
                        closeMenu={ this._closeMenu }
                        addAdmin={ addAdmin }
                        removeAdmin={ removeAdmin }
                        removeUser={ removeUser }
                        resendVerificationEmail={ resendVerificationEmail }
                    />
                </main>
            </div>
        );
    }
}

export const Users = (props) => {
    const {
        selfId,
        users,
        numberOfAdmins,
        userActionState: {
            success,
            error
        },
        resetUserAction,
        activeMenuId,
        showMenu,
        closeMenu,
        addAdmin,
        removeAdmin,
        removeUser,
        resendVerificationEmail
    } = props;

    const content = users.map((user) => {
        const {
            id,
            email,
            verified,
            role,
            active
        } = user;

        return (
            <ManageUser
                key={ id }
                id={ id }
                email={ email }
                verified={ verified }
                role={ role }
                active={ active }
                success={ success.target === id && success }
                error={ error.target === id && error }
                resetUserAction={ resetUserAction }
                isMenuOpen={ activeMenuId === id }
                showMenu={ showMenu }
                closeMenu={ closeMenu }
                isSelf={ selfId === id }
                numberOfAdmins={ numberOfAdmins }
                addAdmin={ addAdmin }
                removeAdmin={ removeAdmin }
                removeUser={ removeUser }
                resendVerificationEmail={ resendVerificationEmail }
            />
        );
    });

    return (
        <div className={ styles.usersContainer }>
            <div className={ styles.usersHeader }>
                Existing users
            </div>
            { content }
        </div>
    );
};

const RightRail = ({ redirectToSubscriptions, name, endDateString, status }) => {
    const endDate = formatUTCDateString(endDateString);

    return (
        <aside className={ styles.rightRail }>
            <div className={ styles.accountSettings }>
                <button className={ styles.accountSettingsText } type="button" onClick={ redirectToSubscriptions }>
                    Back to Subscriptions
                </button>
            </div>
            <div className={ styles.yourAccount }>
                <div>
                    Your account:
                </div>
                <div className={ styles.subName }>
                    { name }: Digital Group Subscription
                </div>
                { status !== STATUS_ACTIVE && (
                    <div className={ styles.activeText }>
                        Active until { endDate }
                    </div>
                ) }
            </div>
        </aside>
    );
};

ManageBulkSubscription.propTypes = {
    errors: PropTypes.object,
    name: PropTypes.string,
    endDate: PropTypes.string,
    redirectToSubscriptions: PropTypes.func.isRequired,
    users: PropTypes.arrayOf(PropTypes.object).isRequired,
    maxUsersCount: PropTypes.number,
    status: PropTypes.string,
    email: PropTypes.string,
    onEmailChange: PropTypes.func.isRequired,
    onAddUser: PropTypes.func.isRequired,
    userActionState: PropTypes.shape({
        success: PropTypes.object.isRequired,
        error: PropTypes.object.isRequired
    }),
    resetUserAction: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    numberOfAdmins: PropTypes.number.isRequired
};

export default ManageBulkSubscription;
